export const ActiveToolMode = Object.freeze({
  NONE: Symbol('none'),
  MIN_HEIGHT_SELECTION: Symbol('select-min-height'), // not used
  SLOPE_START_SELECTION: Symbol('slope-start'),
  SLOPE_SELECTION: Symbol('slope'),
  ADD_POINT: Symbol('add-point'),
  EDIT_POINT: Symbol('edit-point'),
});
